import { FC } from "react";

interface ITitle extends React.ButtonHTMLAttributes<HTMLHeadingElement> {
  title: string;
}

const MenuText: FC<ITitle> = ({ title, ...props }: ITitle) => {
  return (
    <p {...props} className={`font-menu text-menu ${props.className}`}>
      {title}
    </p>
  );
};
export default MenuText;
